var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataListStateful',{attrs:{"title":"Поставки","resource":"shippings","store":"shippings","columns":_vm.columns,"add-route":{ name: 'shipping-new-steps' },"filter-options":_vm.filter,"row-color-fn":_vm.getShippingRowColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }